/* SHUBHAM CREATION - SALES POPUP JS */

const firstNames = [
  "Aarya", "Aadhya", "Aahana", "Aakriti", "Aakanksha", "Aaliya", "Aanya", "Aaravi", "Aarini", "Aarohi",
  "Aarushi", "Aashna", "Aashvi", "Aasmi", "Aastha", "Aayra", "Aayushi", "Abhira", "Adhira", "Adira",
  "Advika", "Advita", "Aesha", "Ahaana", "Aishani", "Aishika", "Aishita", "Akira", "Akshara", "Akshita",
  "Alisha", "Alka", "Alvira", "Amaya", "Amisha", "Amrita", "Amruta", "Anaya", "Anika", "Anisha",
  "Anvi", "Anvika", "Anvitha", "Apeksha", "Aradhya", "Arika", "Arina", "Arpita", "Arshiya", "Arti",
  "Arya", "Ashmita", "Ashvi", "Asmita", "Asmi", "Avani", "Avika", "Avira", "Avni", "Avyukta",
  "Ayesha", "Ayra", "Ayushi", "Bageshri", "Bhavika", "Bhavya", "Bhumika", "Bhuvi", "Brinda", "Chaitali",
  "Chaitra", "Charvi", "Chhavi", "Chitra", "Daksha", "Damini", "Darika", "Darshana", "Darshi", "Deepti", 
  "Devanshi", "Devika", "Devina", "Devyani", "Dhara", "Dharika", "Dhriti", "Dhruti", "Dia", "Diksha",
  "Dimple", "Dipali", "Dipika", "Dipti", "Disha", "Divya", "Drishti", "Driti", "Durva", "Eesha",
  "Eshani", "Eshita", "Eshwari", "Falak", "Gauri", "Gayatri", "Geet", "Geetika", "Gitanjali", "Grishma",
  "Gunjan", "Hamsika", "Harini", "Harsha", "Harshika", "Hema", "Hetvi", "Hiral", "Hrida", "Hridaya",
  "Hrishita", "Isha", "Ishani", "Ishika", "Ishita", "Ishwari", "Iyla", "Jagruti", "Jahnavi", "Janki",
  "Janvi", "Janya", "Jhanvi", "Jiya", "Juhi", "Jyoti", "Kaashvi", "Kaavya", "Kadambari", "Kajal",
  "Kalpita", "Kamini", "Kanika", "Kanishka", "Kanvi", "Karina", "Karishma", "Karuna", "Kashvi", "Kavika",
  "Kavita", "Kavya", "Kaya", "Keerthi", "Kenisha", "Ketaki", "Khushi", "Khyati", "Kiara", "Kiran",
  "Kirtika", "Kirti", "Komal", "Kranti", "Krisha", "Krishika", "Krishita", "Krupa", "Krutika", "Kshama",
  "Kshiti", "Kuhu", "Kumud", "Kumuda", "Kunjal", "Kusum", "Lakshita", "Lavanya", "Leena", "Lekha",
  "Lisha", "Lopa", "Madhavi", "Madhura", "Madhuri", "Mahika", "Mahira", "Mahi", "Mahika", "Malini",
  "Manasi", "Manasvi", "Manika", "Manisha", "Manjiri", "Manvi", "Marisha", "Medha", "Meera", "Meher",
  "Mehul", "Mihika", "Minal", "Mishika", "Mitali", "Mitu", "Mohini", "Mridula", "Mrinal", "Mrunmayi", 
  "Mukta", "Myra", "Naina", "Naira", "Nandini", "Nandita", "Narmada", "Navika", "Navya", "Neel",
  "Neelima", "Neha", "Nehal", "Niharika", "Nikita", "Nima", "Nira", "Nirali", "Nirmala", "Nisha",
  "Nishika", "Nitya", "Niyati", "Ojasvi", "Ojaswini", "Ovi", "Ojal", "Oshini", "Palak", "Pallavi",
  "Pari", "Parika", "Parina", "Parisha", "Parna", "Parthivi", "Pihu", "Pooja", "Poorva", "Pradnya",
  "Pragnya", "Prakriti", "Pranali", "Pranavi", "Prarthana", "Pratibha", "Pratima", "Prerna", "Preeti", 
  "Prema", "Priya", "Priyanka", "Priti", "Rachana", "Radhika", "Raina", "Rajasi", "Rajashree", "Raksha", 
  "Rama", "Ramya", "Rashi", "Rashika", "Rashmi", "Rasika", "Raveena", "Reema", "Rekha", "Renuka", 
  "Reshma", "Rhea", "Riddhi", "Rima", "Rina", "Risha", "Rishika", "Rishita", "Ritu", "Riya", "Rohini",
  "Roma", "Roshni", "Rucha", "Ruchika", "Ruchira", "Rukmini", "Rupa", "Rupali", "Saanvi", "Saavi",
  "Sachi", "Sadhana", "Sagarika", "Sai", "Sailee", "Sakshi", "Saloni", "Samaira", "Samiksha", "Samruddhi"
];

const lastInitials = ["Patil", "Deshmukh", "Deshmane", "Chavan", "Athawale", "Apte", "Jadhav", "Koli", 
    "Sawant", "More", "Ambekar", "Agarkar", "Dixit", "Joshi", "Jagtap", "Gosavi", "Kamble", 
  "Kamat", "Bhujbal", "Bhosale", "Bhandari", "Chitale", "Chaudhari", "Deshpande", "Mohite",
  "Mane", "Sonawane", "Pawar", "Shinde", "Shirke", "Parab", "Zope", "Tambe", "Desai"];

const cities = [
  "Mumbai", "Pune", "Latur", "Chinchwad", "Jalgaon", "Chh Sambhaji Nagar", "Thane", 
  "Pimpri-Chinchwad", "Navi Mumbai", "Solapur", "Mira-Bhayandar", "Amravati", "Nagpur", "Kolhapur", 
  "Thane", "Sangli", "Akola", "Pimpri-Chinchwad", "Dhule", "Parbhani",
  "Ichalkaranji", "Jalna", "Bhusawal", "Nashik", "Panvel", "Badlapur", "Beed", "Udgir", "Satara", "Lonavala"];

let availableProducts = [];
let lastProductId = null;
let lastUsedName = ""; 
let currentTimeout = null;

async function loadProducts() {
  try {
    const popupEl = document.getElementById("shubham-sales-popup");
    const collectionHandle = popupEl ? popupEl.getAttribute("data-collection") : "";
    
    // Performance Cache: Check if we already loaded products this session
    const cacheKey = `shubham_products_${collectionHandle || 'all'}`;
    const cachedData = sessionStorage.getItem(cacheKey);
    
    if (cachedData) {
        availableProducts = JSON.parse(cachedData);
        return;
    }

    // Default URL (All products)
    let fetchUrl = '/products.json?limit=150';
    
    // If we are in a collection, try fetching from that collection first
    if (collectionHandle && collectionHandle !== "") {
        fetchUrl = `/collections/${collectionHandle}/products.json?limit=150`;
    }

    let response = await fetch(fetchUrl);
    let data = await response.json();
    
    // If the collection didn't have products (or fetch failed), fallback to store-wide
    if (!data.products || data.products.length === 0) {
        response = await fetch('/products.json?limit=150');
        data = await response.json();
    }
    
    availableProducts = data.products.filter(product => {
      return product.variants.some(variant => variant.available);
    });

    // Save to session cache for faster page loads
    sessionStorage.setItem(cacheKey, JSON.stringify(availableProducts));

  } catch (error) {
    console.error("Error loading products for popup:", error);
  }
}

function getRandomItem(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function getRandomTimeAgo() {
  const mins = Math.floor(Math.random() * 14) + 1; 
  return mins + " mins ago";
}

function getRandomDelay() {
  const min = 12000;  // 12 seconds
  const max = 35000;  // 35 seconds
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getDifferentProduct() {
  if (availableProducts.length === 0) return null;
  
  let product;
  let attempts = 0;
  do {
    product = getRandomItem(availableProducts);
    attempts++;
  } while (product.id === lastProductId && attempts < 10);

  lastProductId = product.id;
  return product;
}

function generateUniqueName() {
  let generatedName;
  let attempts = 0;
  
  do {
    const randomFirst = getRandomItem(firstNames);
    const randomLast = getRandomItem(lastInitials);
    generatedName = `${randomFirst} ${randomLast}`;
    attempts++;
  } while (generatedName === lastUsedName && attempts < 5);
  
  lastUsedName = generatedName;
  return generatedName;
}

function showFakeSale() {
  if (!availableProducts.length) return;

  const popup = document.getElementById("shubham-sales-popup");
  if (!popup) return; // Safety check

  const product = getDifferentProduct();
  if (!product) return; 

  const dynamicName = generateUniqueName();
  const randomCity = getRandomItem(cities);

  // Upgraded image width to 120 for retina display crispness
  // Wrapped entire content in <a> tag for better mobile tap targets
  popup.innerHTML = `
    <span class="shubham-sales-close" id="shubham-sales-close">&times;</span>
    <a href="/products/${product.handle}" style="text-decoration: none; color: inherit; display: flex; align-items: center; gap: 12px; width: 100%;">
      <img src="${product.images[0].src}&width=120" alt="${product.title}" style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px;">
      <div class="shubham-sales-content">
        <strong>${dynamicName}</strong> from ${randomCity}<br>
        purchased <strong>${product.title}</strong><br>
        <small>${getRandomTimeAgo()} ✓ Verified</small>
      </div>
    </a>
  `;

  // Attach close event (with preventDefault to stop the link click)
  document.getElementById("shubham-sales-close").addEventListener("click", (e) => {
    e.preventDefault(); 
    popup.classList.remove("show");
  });

  popup.classList.add("show");

  // Hide it after 6 seconds
  setTimeout(() => {
    popup.classList.remove("show");
  }, 6000); 

  // Queue up the next popup
  currentTimeout = setTimeout(showFakeSale, getRandomDelay());
}

document.addEventListener("DOMContentLoaded", async function() {
  await loadProducts();
  if(availableProducts.length > 0) {
    currentTimeout = setTimeout(showFakeSale, 8000); 
  }
});